import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DropdownButton, MenuItem } from "react-bootstrap";

class MultiSelectToolbar extends React.PureComponent {
	render() {
		const selectedItems = Array.isArray(this.props.selectedItems) ? this.props.selectedItems : [];
		if (selectedItems.length === 0) {
			return null;
		}

		const showSelectAll = this.props.showSelectAll !== false;
		const showSelectPage = this.props.showSelectPage === true;
		const closeDisabled = this.props.closeDisabled === true;
		const selectAllLabel = this.props.selectAllLabel || "Select All";
		const selectPageLabel = this.props.selectPageLabel || "Select Page";
		const showSelectionActions = showSelectAll || showSelectPage;

		return (
			<div className="multiSelectToolbar" role="toolbar" aria-label="Selected items actions">
				<div className="multiSelectToolbarSurface">
					<div className="multiSelectToolbarLayout">
						<div className="multiSelectToolbarSummary">
							<button
								type="button"
								className="multiSelectToolbarClear"
								onClick={closeDisabled ? undefined : this.props.onClickClose}
								disabled={closeDisabled}
								aria-label="Clear selection"
								title="Clear selection"
							>
								<FontAwesomeIcon icon="times" />
							</button>
							<div className="multiSelectToolbarCount" aria-live="polite" aria-label={`${selectedItems.length} selected`}>
								<span className="multiSelectToolbarCountValue">{selectedItems.length}</span>{" "}
								<span className="multiSelectToolbarCountLabel">selected</span>
							</div>
						</div>

						<div className="multiSelectToolbarCommands">
							{showSelectionActions &&
								<div className="multiSelectToolbarDesktopSelectionActions">
									{showSelectAll &&
										<button type="button" onClick={this.props.onClickSelectAll}>
											{selectAllLabel}
										</button>
									}
									{showSelectPage &&
										<button type="button" onClick={this.props.onClickSelectPage}>
											{selectPageLabel}
										</button>
									}
								</div>
							}

							{showSelectionActions &&
								<div className="multiSelectToolbarMobileSelectionActions">
									<DropdownButton
										id="multi-select-selection-menu"
										title={<span><FontAwesomeIcon icon="check-square" /> Select</span>}
										bsStyle="link"
										pullRight
									>
										{showSelectAll &&
											<MenuItem eventKey="all" onClick={this.props.onClickSelectAll}>
												{selectAllLabel}
											</MenuItem>
										}
										{showSelectPage &&
											<MenuItem eventKey="page" onClick={this.props.onClickSelectPage}>
												{selectPageLabel}
											</MenuItem>
										}
									</DropdownButton>
								</div>
							}

							{this.props.children &&
								<div className="multiSelectToolbarBulkActions">
									{this.props.children}
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default MultiSelectToolbar;
